import { Boundaries } from "@planzone/core";
import { Identifiable, Project } from "@planzone/dto";

function handleEditProjectWeatherReportRequest(
  project: Identifiable<Project>,
  req: Boundaries["editProjectWeatherReport"]["request"],
): Identifiable<Project> {
  return project.uuid === req.project.uuid
    ? {
        ...project,
        attributes: { ...project.attributes, weather: req.weatherReport },
      }
    : project;
}

function handleEditProjectWeatherReportSuccess(
  project: Identifiable<Project>,
  req: Boundaries["editProjectWeatherReport"]["success"],
): Identifiable<Project> {
  return project.uuid === req.project.uuid
    ? {
        ...project,
        attributes: { ...project.attributes, weather: req.weatherReport },
      }
    : project;
}

function handleEditProjectWeatherReportFailure(
  project: Identifiable<Project>,
  req: Boundaries["editProjectWeatherReport"]["failure"],
): Identifiable<Project> {
  return project.uuid === req.project.uuid ? req.project : project;
}

export {
  handleEditProjectWeatherReportRequest,
  handleEditProjectWeatherReportSuccess,
  handleEditProjectWeatherReportFailure,
};
